/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BanUserFromCommunityBody
 */
export interface BanUserFromCommunityBody {
    /**
     * 
     * @type {string}
     * @memberof BanUserFromCommunityBody
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BanUserFromCommunityBody
     */
    groupingId: string;
}

/**
 * Check if a given object implements the BanUserFromCommunityBody interface.
 */
export function instanceOfBanUserFromCommunityBody(value: object): value is BanUserFromCommunityBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('groupingId' in value) || value['groupingId'] === undefined) return false;
    return true;
}

export function BanUserFromCommunityBodyFromJSON(json: any): BanUserFromCommunityBody {
    return BanUserFromCommunityBodyFromJSONTyped(json, false);
}

export function BanUserFromCommunityBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BanUserFromCommunityBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'groupingId': json['groupingId'],
    };
}

export function BanUserFromCommunityBodyToJSON(json: any): BanUserFromCommunityBody {
    return BanUserFromCommunityBodyToJSONTyped(json, false);
}

export function BanUserFromCommunityBodyToJSONTyped(value?: BanUserFromCommunityBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'groupingId': value['groupingId'],
    };
}

